package pl.zar.tikthrow.shared.dto

import kotlin.time.Instant
import kotlinx.serialization.Serializable
import pl.zar.tikthrow.shared.domain.ContentType
import pl.zar.tikthrow.shared.domain.Platform
import pl.zar.tikthrow.shared.domain.StalenessIndicator

@Serializable
data class PostDto(
    val id: String,
    val accountId: String,
    val platform: Platform,
    val contentType: ContentType,
    val textContent: String?,
    val mediaUrl: String?,
    val thumbnailUrl: String?,
    val authorName: String,
    val authorAvatarUrl: String?,
    val postUrl: String,
    val publishedAt: Instant,
    val likeCount: Int
)

@Serializable
data class PlatformGroupDto(
    val platform: Platform,
    val posts: List<PostDto>
)

@Serializable
data class FeedResponseDto(
    val platformGroups: List<PlatformGroupDto>,
    val stalenessIndicator: StalenessIndicator,
    val lastUpdated: Instant,
    val totalPosts: Int
)
